import { render, staticRenderFns } from "./PricingBI.vue?vue&type=template&id=2dadae3c"
import script from "./PricingBI.vue?vue&type=script&lang=js"
export * from "./PricingBI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports